import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Input } from '../../../elements/input';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../shared/http-client';
import { FilterFooter } from '../../../elements/filter-footer';
import { Toggle } from '../../../elements/toggle';
import { RadioGroup } from '../../../elements/radio-group';


const initialValues = {
    name: '',
    identification_number: '',
    available: null
};

export const ConductoresFilter = ({
    item,
    doFilter,
    close
}: {
    item?: any;
    close: () => void;
    doFilter: (item: any) => void;
}) => {
    const { t } = useTranslation();
    const { api, state } = useHttpClient();
    const [data, setData] = useState<any | null>(null);

    useEffect(() => {
        if (item) {
            setData(item);
        }
    }, [item]);

    const beforeSubmit = (values: any | null) => {
        let after = { ...values };

        for (let key in after) {
            if (!after[key]) {
                delete after[key];
            }
        }

        return after;
    };

    const onSubmit = async (values: any | null) => {
        //
        const enviaremos = beforeSubmit(values);

        doFilter(enviaremos);
    };

    useEffect(() => {
        if (state.error) {
            toast.error(state.error.detail);
        }
    }, [state]);

    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={data || initialValues}
                validateOnBlur={true}
                onSubmit={onSubmit}
            >
                {({
                    values,
                    errors,
                    setFieldValue,
                    handleSubmit,
                    isSubmitting
                }) => (
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <Input
                            name="identification_number"
                            label={'common.label.nif-nie'}
                            type="text"
                            placeholder={'common.label.nif-nie'}
                            value={data?.identification_number || values.identification_number}
                            onChange={(value) =>
                                setFieldValue('identification_number', value.identification_number)
                            }
                        />
                        <Input
                            name="full_name"
                            label={'common.label.full_name'}
                            type="text"
                            placeholder={'common.label.full_name'}
                            value={data?.full_name || values.full_name}
                            onChange={(value) =>
                                setFieldValue('full_name', value.full_name)
                            }
                        />
                        <RadioGroup
                            name="available"
                            label={t("common.form-label.disponible")}
                            value={values.available}
                            items={[
                                { id: 'true', label: t('common.label.yes') },
                                { id: 'false', label: t('common.label.no') }
                            ]}
                            onChange={(newValue) => setFieldValue('available', newValue.available)}
                        />

                        <FilterFooter
                            item={item}
                            doDelete={() => doFilter({})}
                            doSubmit={handleSubmit}
                            close={close}
                        />
                    </form>
                )}
            </Formik>
        </div>
    );
};